import setCookie from './setCookie';

export default (key, path = '/') => {
	/*
		Setting a cookie's expiration to anything 0 or below "expires" the cookie immediately, which removes it.
		Because the cookie will be immediate removed, the value does not matter, but it must be a string, convention is to use ''
	*/
	setCookie(key, '', 0, path);
};
